export default __webpack_public_path__ + "static/media/user_profile_icon.29b926d9.svg";